<template>
  <div class="c-media-block mb-10">
    <div class="relative h-0 pb-9/16">
      <template v-if="isMobile">
        <Picture
          v-if="image"
          v-bind="image"
          :mobile="[460, 345]"
          lazy
          img-class="absolute top-0 left-0 w-full h-full object-cover"
          width="460"
          height="345"
        />
        <div
          v-if="video"
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >
          <VideoOverlayTrigger :video="video" />
        </div>
      </template>
      <div
        v-else
        class="c-media-block__container absolute top-0 left-0 w-full h-full bg-center bg-no-repeat bg-cover max-w-full"
      >
        <Picture
          v-if="image && !video"
          v-bind="image"
          :mobile="[768, 432]"
          lazy
          img-class="absolute top-0 left-0 w-full h-full object-cover"
          width="768"
          height="432"
        />
        <template v-if="video">
          <template v-if="video.youtubeId">
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <button
                type="button"
                class="lty-playbtn w-16 h-16 flex bg-white items-center justify-center rounded-full shadow focus:outline-none focus:bg-beige"
                @click="playVideo"
              >
                <span class="icon-play" />
              </button>
            </div>
            <youtube-video
              ref="videoPlayer"
              :class="{'z-30 relative': isPlaying}"
              :video-id="video.youtubeId"
            />
          </template>
          <Video
            v-else-if="video.src"
            :model="video.src"
            :poster="!image ? video.poster : null"
          >
            <Picture
              v-if="image"
              v-bind="image"
              :mobile="[768, 432]"
              lazy
              img-class="absolute top-0 left-0 w-full h-full object-cover"
              width="768"
              height="432"
            />
          </Video>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Video from '@/components/Video.vue'
import Picture from '@/components/Picture.vue'
import VideoOverlayTrigger from '@/components/VideoOverlayTrigger.vue'
import YoutubeVideo from '@/components/YoutubeVideo.vue'

export default {
  components: {
    Video,
    Picture,
    VideoOverlayTrigger,
    YoutubeVideo
  },
  props: {
    video: {
      type: Object,
      default: null
    },
    image: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isMobile: window.matchMedia('(max-width: 639px)').matches,
      isPlaying: false
    }
  },
  methods: {
    playVideo() {
      this.$refs.videoPlayer.playVideo()
    }
  }
}
</script>

<style>
  @media screen and (min-width: 800px) {
    .c-media-block {
      @apply max-w-860 w-860;
      position: relative;
    }

    [dir="ltr"] .c-media-block {
      left: 50%;
      transform: translateX(-50%);
    }

    [dir="rtl"] .c-media-block {
      right: 50%;
      transform: translateX(50%);
    }
  }
  .c-media-block > div {
    max-width: 100% !important;
  }
  .c-media-block__container {
    max-width: 100% !important;
  }
  .c-youtube-container {
    position: absolute;
    width: 100%;
    height: 100%;
    max-width: 100% !important;
    max-height: 100vh;
    top: 50%;
    transform: translateY(-50%);
  }
  .c-youtube-container iframe {
    width: 100%;
    height: 100%;
  }
  .c-visual-block-youtube .c-youtube-container {
    background: black;
    display: flex;
    align-items: center;
  }
  .c-visual-block-youtube .c-youtube-container iframe {
    aspect-ratio: 16/9;
    height: auto;
  }
</style>
